<template>
    <o-modal @showModal="showModal" @close="closeModal">
        <template v-slot:header>
            {{ modalTitle }}
        </template>
        <template v-slot:body>
            <o-form autocomplete="off">
                <div v-if="errors.length">
                    <div class="alert alert-danger">
                        <p>
                            <b>Please correct the following error(s):</b>
                            <ul>
                                <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                            </ul>
                        </p>
                    </div>
                </div>
                
                <o-form-group title="Upload Image" name="uploadImage" class="text-start mb-2">
                    <o-image-input :imageurl="item.image" @selectImage="imageSelected" />
                </o-form-group>
                
                <div class="d-flex d-inline-block">
                    <div class="me-2">
                        <o-button @click="uploadImage" :variant="'primary'" type="button">Upload</o-button>
                    </div>
                </div>
            </o-form>
        </template>
    </o-modal>
</template>

<script>
import { OModal, OForm, OFormGroup, OButton, OImageInput } from '@/components/OmnihControl';
import { mapActions } from 'vuex';

export default {
    name: 'UploadReceipt',
    components: {
        OImageInput,
        OModal,
        OForm,
        OFormGroup,
        OButton,
    },
    props: {
        editedItem: Object,
    },
    data() {
        return {
            item: {
                image: '',
            },
            errors: [],
            modalTitle: 'Upload Receipt', 
        };
    },
    mounted: function() {
        if (this.editedItem && Object.keys(this.editedItem).length > 0 && this.editedItem.image != null) {        
            this.item.image = this.editedItem.image; 
        }
    },
    methods: {
        ...mapActions('member', ['import']),

        closeModal() {
            this.$emit('closeModal');
        },
        imageSelected(image) {
            this.item.image = image;
        },
        uploadImage() {
            this.errors = [];

            if (!this.item.image) {
                this.errors.push('Image is required.'); 
                return;
            }

            const formData = new FormData();
            formData.append('image', this.item.image);
            this.$emit('saveDetail', formData);
            this.closeModal();
        }
    },
}
</script>

<style>
.spinner {
    position: fixed;
    z-index: 3;
    top: 0;
    left: 0;
    background-color: rgba(255, 255, 255, 0.5);
    height: 100%;
    width: 100%;
}
.spinner-position {
    display: block;
    position: fixed;
    z-index: 1031;
    top: 50%;
    right: 50%;
    margin-top: 5px; 
    margin-left: 80px; 
}
</style>